<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>기부처 등록</strong></div>
			<h2 class="h_sub">기부처 등록</h2>
		</div>

    <DonationCategoryManageCreateForm/>
  </div>
</template>

<script>
import DonationCategoryManageCreateForm from '@/components/admin/etc/DonationCategoryManageCreateForm.vue';

export default {
  components: {
    DonationCategoryManageCreateForm: DonationCategoryManageCreateForm
  }
}
</script>
<style lang="">

</style>